import isNil from 'lodash-es/isNil'
import { StringParam, useQueryParam, useQueryParams } from 'use-query-params'

import { useQueryPage } from '@fourthwall/utils'

type FilterParams = {
  types?: string
}

export const useFilterPosts = () => {
  const { setPage } = useQueryPage()
  const [queryParams, setQueryParams] = useQueryParams({
    types: StringParam,
  })
  const [searchQueryParam, setSearchQueryParam] = useQueryParam('searchQuery', StringParam)

  const resetFiltersParams = () => {
    setPage(undefined)
    setQueryParams({
      types: undefined,
    })
  }

  const setFiltersParams = (params: FilterParams) => {
    setPage(undefined)
    setQueryParams(params)
  }

  const hasFilterParams =
    Object.values(queryParams).some((param) => !isNil(param)) || !!searchQueryParam

  return {
    filtersParams: queryParams,
    setFiltersParams,
    searchQueryParam,
    setSearchQueryParam,
    resetFiltersParams,
    hasFilterParams,
  }
}
